<template>
  <div>
    <basic-portlet title="Login As User" icon="la la-key">
      <login-as-user />
    </basic-portlet>
  </div>
</template>

<script>
import LoginAsUser from "VuePartials/Admin/LoginAsUser";

export default {
  components: { LoginAsUser },
};
</script>
